<template>
  <v-dialog :value="show" persistent width="35%" transition="dialog-transition">
    <v-card>
      <v-card-title class="w-100 justify-center">
        <h1 class="mt-3">
          ¿Cuando desea aplicar los cambios?
        </h1>
      </v-card-title>
      <v-card-text class="px-4">
        <v-radio-group v-model="valueSelected" :hide-details="true">
          <v-radio v-for="(item, index) in items" :key="`radio-checker-seleted-${index}`" :label="item.text"
            :value="item.value"></v-radio>
        </v-radio-group>
        <v-text-field v-model="text" :label="`Escriba '${permissionStatement}' para continuar.`" item-text="text"
          item-value="value" color="grey lighten-1" >
        </v-text-field>
      </v-card-text>
      <v-card-actions class="px-4 pb-3 d-flex">
        <v-spacer class="w-100"></v-spacer>
        <v-btn :disabled="textValidation && disabled" @click="close" class="btn btn--large" flat>
          Cerrar
        </v-btn>
        <v-btn :disabled="!textValidation || disabled" @click="save" class="k-orange-linear-text" flat>
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      disabled: true,
      valueSelected: 'now',
      items: [
        {
          value: 'now',
          text: 'Ahora',
        },
        {
          value: 'after load',
          text: 'En la proxima carga',
        },
      ],
      permissionStatement: 'estoy de acuerdo',
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    textValidation() {
      return this.text === this.permissionStatement;
    },
  },
  methods: {
    save() {
      this.disabled = true;
      this.$emit('accept', { value: this.valueSelected });
    },
    close() {
      this.disabled = true;
      this.valueSelected = 'now';
      this.text = '';
      this.$emit('close');
    },
  },
  watch: {
    show() {
      if (!this.show) {
        this.close();
      }
    },
    textValidation() {
      if (this.textValidation && this.disabled) {
        this.disabled = false;
      }
    }
  },
};
</script>

<style scoped>
span {
  font-size: 1.8rem !important;
  font-weight: lighter !important;
  /* color: #ff7c64; */
}

.disabled:hover {
  cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/templateV2/modal/DoubleCheck.vue